import { useRef, useState } from "react";

import type { Swiper as SwiperObject } from "swiper";
import { Navigation } from "swiper/modules";
import { Swiper, SwiperSlide } from "swiper/react";

import Image from "./Image";

type Props = {
  images: Lot.Image[];
  strings: Lot.Localizations;
  title: string;
  artist_name?: string;
  artist_lifespan?: string;
  object_type?: string;
  year?: string;
};

export default function Images(props: Props) {
  const { images } = props;
  const [image, setImage] = useState(props.images ? props.images[0] : null);
  const swiperRef = useRef<SwiperObject>(null);

  const swipeTo = (image: Lot.Image) => {
    if (swiperRef.current) {
      swiperRef.current.slideTo(images.indexOf(image));
    }
  };

  if (!images || images.length === 0) {
    return (
      <div className="lot-images">
        <div className="image">
          <div className="fallback" />
        </div>
      </div>
    );
  } else if (images.length > 1) {
    return (
      <div className="lot-images">
        <Swiper
          modules={[Navigation]}
          navigation
          slidesPerView={1}
          onSwiper={(s) => (swiperRef.current = s)}
          onSlideChange={(s) => setImage(images[s.activeIndex])}>
          {images.map((img, index) => (
            <SwiperSlide key={img.id}>
              <Image image={img} isFirst={index === 0} {...props} />
            </SwiperSlide>
          ))}
        </Swiper>
        <div className="slider-pagination">
          {images.map((img) => {
            return (
              <button
                key={img.id}
                onClick={() => swipeTo(img)}
                className={img == image ? "current" : ""}>
                <img
                  src={img.small}
                  alt=""
                  width={img.width}
                  height={img.height}
                  loading="eager"
                />
              </button>
            );
          })}
        </div>
      </div>
    );
  } else {
    return (
      <div className="lot-images">
        <Image image={image} isFirst={true} {...props} />
      </div>
    );
  }
}
